var exports = {
  "p_": "BadgeListModal.module__list___bmpEa3",
  "nM": "BadgeListModal.module__row___bmpEa3",
  "Sl": "BadgeListModal.module__image___bmpEa3",
  "pG": "BadgeListModal.module__caption___bmpEa3",
  "Qq": "BadgeListModal.module__text___bmpEa3",
  "DD": "BadgeListModal.module__title___bmpEa3",
  "n8": "BadgeListModal.module__line___bmpEa3",
};

module.exports = exports;
